// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Pulse animation for reconnecting indicator */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background-color: #0d0d0f;
  color: #e2e2e6;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  width: 100%;
  min-height: 100vh;
}

/* Dashboard Container */
.dashboard-container {
  width: 100%;
  min-height: 100vh;
  background-color: #0e0e0e;
  display: flex;
  flex-direction: column;
}

/* Price Header */
.price-header {
  background: linear-gradient(180deg, #1e1e23 0%, #181820 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.crypto-selector {
  position: relative;
}

.selector-button {
  background: linear-gradient(180deg, #262630 0%, #1e1e28 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  color: #e5e5e5;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.selector-button:hover {
  background: linear-gradient(180deg, #2e2e3a 0%, #252530 100%);
  border-color: rgba(255, 255, 255, 0.18);
}

.selected-pair {
  display: flex;
  align-items: center;
  gap: 10px;
}

.crypto-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #2a2a2a;
  flex-shrink: 0;
  object-fit: cover;
  display: block;
}

.dropdown-arrow {
  color: #999;
  font-size: 12px;
}

.selector-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #1c1c22;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  width: 320px;
  max-height: 480px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.04);
  z-index: 1000;
}

.search-box {
  padding: 12px;
  border-bottom: 1px solid #2a2a2a;
}

.search-box input {
  width: 100%;
  background-color: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  padding: 10px 12px;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
}

.search-box input:focus {
  border-color: #0052ff;
}

.pairs-list {
  max-height: 400px;
  overflow-y: auto;
}

.pair-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pair-item:hover {
  background-color: #2a2a2a;
}

.pair-item.active {
  background-color: #0052ff;
}

.pair-info {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.base-asset {
  font-weight: 600;
  font-size: 14px;
}

.quote-asset {
  color: #999;
  font-size: 13px;
}

.price-stats {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat .value {
  font-size: 18px;
  font-weight: 600;
  color: #e2e2e6;
  font-feature-settings: 'tnum' 1;
  letter-spacing: -0.2px;
}

.stat .label {
  font-size: 11px;
  color: #6e6e7a;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  font-weight: 500;
}

.stat.positive .value {
  color: #26a69a;
}

.stat.negative .value {
  color: #ef5350;
}

/* Trading Grid */
.trading-grid {
  display: grid;
  grid-template-columns: 320px 1fr 350px;
  gap: 1px;
  background-color: rgba(255, 255, 255, 0.05);
  flex: 1;
  height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
}

.order-book-panel,
.chart-panel,
.trade-history-panel {
  background-color: #1a1a1a;
  overflow-y: auto;
}

.order-book-panel {
  display: flex;
  flex-direction: column;
}

.chart-panel {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Order Book */
.order-book {
  background-color: #1a1a1a;
  padding: 16px;
  flex: 1;
}

.order-book h3 {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  color: #5a5a6a;
  padding-left: 8px;
  border-left: 2px solid rgba(38, 166, 154, 0.5);
}

.order-book-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 8px 0;
  font-size: 10px;
  color: #4e4e5e;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.order-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 5px 4px;
  font-size: 12.5px;
  font-family: 'Monaco', 'Courier New', monospace;
  font-feature-settings: 'tnum' 1;
  border-radius: 3px;
  transition: background-color 0.1s ease;
}

.order-row:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.order-row.bid {
  color: #2bbdb3;
}

.order-row.ask {
  color: #f0564a;
}

.spread {
  display: flex;
  justify-content: space-between;
  padding: 9px 10px;
  margin: 6px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(38, 166, 154, 0.04);
  border-radius: 4px;
  font-size: 11px;
  color: #5a5a6e;
  letter-spacing: 0.3px;
}

.spread-value {
  font-weight: 600;
  color: #c0c0cc;
  font-feature-settings: 'tnum' 1;
}

.aggregation-control {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #2a2a2a;
  font-size: 12px;
}

.aggregation-control button {
  background-color: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  color: #e5e5e5;
  width: 28px;
  height: 28px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.aggregation-control button:hover {
  background-color: #333;
}

/* Price Chart */
.price-chart-container {
  background-color: #1a1a1a;
  padding: 12px 16px 4px 16px;
  position: relative;
  overflow-x: hidden;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.chart-header h3 {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  color: #5a5a6a;
  padding-left: 8px;
  border-left: 2px solid rgba(38, 166, 154, 0.5);
}

.chart-controls {
  display: flex;
  gap: 8px;
}

.chart-controls select,
.overlay-btn {
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 6px 12px;
  color: #c0c0cc;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.chart-controls select:hover,
.overlay-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
}

.chart-data-bar {
  display: flex;
  gap: 20px;
  padding: 8px 0;
  margin-bottom: 12px;
  font-size: 12px;
  font-family: 'Monaco', 'Courier New', monospace;
  color: #999;
}

.chart-data-bar span {
  color: #e5e5e5;
}

.chart-canvas {
  width: 100%;
  height: 515px;
  position: relative;
}

.chart-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 14px;
}

.mid-market-price {
  position: absolute;
  top: 56px;
  right: 32px;
  background: rgba(18, 18, 24, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 14px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.price-label {
  font-size: 11px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.price-value {
  font-size: 15px;
  font-weight: 600;
  font-family: 'Monaco', 'Courier New', monospace;
  font-feature-settings: 'tnum' 1;
  color: #2bbdb3;
  letter-spacing: -0.3px;
}

/* Trade History */
.trade-history {
  background-color: #1a1a1a;
  padding: 16px;
  height: 100%;
  overflow-y: auto;
}

.trade-history-header {
  margin-bottom: 12px;
}

.trade-history-header h3 {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  color: #5a5a6a;
  padding-left: 8px;
  border-left: 2px solid rgba(38, 166, 154, 0.5);
}

.trade-history-header .columns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 8px 0;
  font-size: 10px;
  color: #4e4e5e;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.trades-list {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.trade-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 7px 4px;
  font-size: 11.5px;
  font-family: 'Monaco', 'Courier New', monospace;
  font-feature-settings: 'tnum' 1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 3px;
  transition: background-color 0.1s ease;
}

.trade-row:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.trade-row.buy {
  color: #2bbdb3;
}

.trade-row.sell {
  color: #f0564a;
}

/* Loading and No Data States */
.loading,
.no-data,
.no-results {
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 13px;
}

/* Orders Panel */
.orders-panel {
  background-color: #1a1a1a;
  padding: 16px;
  border-top: 1px solid #2a2a2a;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Responsive Design */
@media (max-width: 1400px) {
  .trading-grid {
    grid-template-columns: 280px 1fr 240px;
  }
}

@media (max-width: 1024px) {
  .trading-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
  }

  .price-stats {
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .price-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .price-stats {
    width: 100%;
    justify-content: space-between;
  }

  .stat .value {
    font-size: 16px;
  }
}

/* Order Form */
.order-form {
  background-color: #1a1a1a;
  padding: 10px 14px;
  border-radius: 8px;
  margin: 0 12px 8px 12px;
  position: relative;
  z-index: 1;
}

.order-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.order-form h3 {
  font-size: 18px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0;
}

.settings-icon-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.settings-icon-btn:hover {
  opacity: 1;
}

.side-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
}

.side-btn {
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: rgba(255, 255, 255, 0.04);
  color: #6e6e7e;
}

.side-btn.buy.active {
  background: linear-gradient(135deg, #26a69a 0%, #1d8a80 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 2px 8px rgba(38, 166, 154, 0.3);
}

.side-btn.sell.active {
  background: linear-gradient(135deg, #ef5350 0%, #c62828 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 2px 8px rgba(239, 83, 80, 0.3);
}

.side-btn:hover:not(.active) {
  background-color: rgba(255, 255, 255, 0.07);
  color: #a0a0b0;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 8px 10px;
  gap: 8px;
  transition: border-color 0.15s ease;
}

.input-group:focus-within {
  border-color: rgba(38, 166, 154, 0.5);
}

.input-group input {
  flex: 1;
  background: transparent;
  border: none;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
}

.input-group input::placeholder {
  color: #666;
}

.input-icon-btn {
  background-color: #333;
  border: none;
  color: #999;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.input-icon-btn:hover {
  background-color: #3a3a3a;
}

.currency {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  padding-left: 8px;
  border-left: 1px solid #3a3a3a;
}

.fee-info {
  margin: 10px 0 8px 0;
  padding: 10px 0;
  border-top: 1px solid #2a2a2a;
  border-bottom: 1px solid #2a2a2a;
}

.fee-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.fee-row:last-child {
  margin-bottom: 0;
}

.fee-row.total-row {
  font-weight: 600;
  color: #e5e5e5;
  margin-top: 6px;
}

.place-order-btn {
  width: 100%;
  padding: 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 8px;
}

.place-order-btn.buy {
  background: linear-gradient(135deg, #26a69a 0%, #1a8c82 100%);
  color: #fff;
  box-shadow: 0 2px 12px rgba(38, 166, 154, 0.25);
}

.place-order-btn.sell {
  background: linear-gradient(135deg, #ef5350 0%, #c0392b 100%);
  color: #fff;
  box-shadow: 0 2px 12px rgba(239, 83, 80, 0.25);
}

.place-order-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.place-order-btn:active:not(:disabled) {
  transform: translateY(0);
}

.place-order-btn:disabled {
  opacity: 0.25;
  cursor: not-allowed;
  box-shadow: none;
}

/* Order Status Message */
.order-status-message {
  padding: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 6px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  animation: slideIn 0.3s ease-in-out;
}

.order-status-message.success {
  background-color: #1a3a1a;
  border: 1px solid #2a5a2a;
  color: #90EE90;
}

.order-status-message.error {
  background-color: #3a1a1a;
  border: 1px solid #5a2a2a;
  color: #ff6b6b;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Settings Modal */
.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
}

.settings-modal {
  background: linear-gradient(180deg, #1e1e24 0%, #181820 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.settings-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 4px 0;
}

.settings-subtitle {
  font-size: 13px;
  color: #999;
  margin: 0;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 32px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #e5e5e5;
}

.settings-section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #e5e5e5;
  margin-bottom: 16px;
}

.toggle-indicator {
  color: #26a69a;
  font-size: 12px;
}

.slider-group {
  background-color: #2a2a2a;
  border-radius: 8px;
  padding: 16px;
}

.slider {
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #26a69a 0%, #26a69a 25%, #3a3a3a 25%, #3a3a3a 100%);
  border-radius: 2px;
  outline: none;
  margin-bottom: 12px;
  -webkit-appearance: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #26a69a;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #26a69a;
  cursor: pointer;
  border: none;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.slider-value {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #1a1a1a;
  padding: 6px 12px;
  border-radius: 6px;
}

.slider-value span:first-child {
  color: #e5e5e5;
  font-weight: 600;
  font-size: 14px;
}

.pause-btn {
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 12px;
  padding: 0 4px;
}

.participants-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.participant-card {
  background-color: #2a2a2a;
  border: 2px solid #2a2a2a;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
}

.participant-card.active {
  border-color: #26a69a;
  background-color: rgba(38, 166, 154, 0.1);
}

.participant-card:hover {
  background-color: #333;
}

.participant-card.active:hover {
  background-color: rgba(38, 166, 154, 0.15);
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
  margin-bottom: 4px;
}

.card-subtitle {
  font-size: 12px;
  color: #999;
}

.execution-mode-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mode-card {
  background-color: #2a2a2a;
  border: 2px solid #2a2a2a;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;
}

.mode-card.active {
  border-color: #26a69a;
  background-color: #26a69a;
}

.mode-card:hover:not(.active) {
  background-color: #333;
}

.mode-title {
  font-size: 16px;
  font-weight: 600;
  color: #e5e5e5;
  margin-bottom: 8px;
}

.mode-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 4px;
}

.mode-card:not(.active) .mode-subtitle {
  color: #999;
}

.mode-detail {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}

.mode-card:not(.active) .mode-detail {
  color: #666;
}

.provider-type-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.provider-type-card {
  background-color: #2a2a2a;
  border: 2px solid #2a2a2a;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
}

.provider-type-card:first-child {
  grid-column: 1 / -1;
}

.provider-type-card.active {
  border-color: #26a69a;
  background-color: rgba(38, 166, 154, 0.1);
}

.provider-type-card:hover {
  background-color: #333;
}

.provider-type-card.active:hover {
  background-color: rgba(38, 166, 154, 0.15);
}

.settings-section--disabled {
  opacity: 0.4;
  pointer-events: none;
  user-select: none;
}

.coming-soon-badge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #6e6e7e;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 3px 8px;
}

.settings-actions {
  display: flex;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #2a2a2a;
}

.reset-btn {
  flex: 1;
  padding: 14px;
  background-color: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: #e5e5e5;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.reset-btn:hover {
  background-color: #333;
}

.save-btn {
  flex: 2;
  padding: 14px;
  background: linear-gradient(135deg, #26a69a 0%, #1a8c82 100%);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 10px rgba(38, 166, 154, 0.25);
}

.save-btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(38, 166, 154, 0.35);
}

/* Authentication Styles */
.login-container,
.verify-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background-color: #0e0e0e;
}

.login-container h1 {
  color: #e5e5e5;
  margin-bottom: 32px;
  font-size: 32px;
  font-weight: 600;
}

.login-container form {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-container input[type="email"] {
  padding: 14px 16px;
  font-size: 16px;
  background-color: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 8px;
  color: #e5e5e5;
  outline: none;
  transition: border-color 0.2s;
}

.login-container input[type="email"]:focus {
  border-color: #4F46E5;
}

.login-container input[type="email"]::placeholder {
  color: #666;
}

.login-container button {
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 500;
  background-color: #4F46E5;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-container button:hover:not(:disabled) {
  background-color: #4338CA;
}

.login-container button:disabled {
  background-color: #2a2a2a;
  cursor: not-allowed;
  opacity: 0.6;
}

.success-message,
.error-message {
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
}

.success-message {
  background-color: #1a3a1a;
  border: 1px solid #2a5a2a;
  color: #90EE90;
}

.success-message h2 {
  font-size: 20px;
  margin-bottom: 8px;
}

.error-message {
  background-color: #3a1a1a;
  border: 1px solid #5a2a2a;
  color: #ff6b6b;
}

.auth-card {
  background-color: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  padding: 32px;
  max-width: 400px;
  text-align: center;
}

.auth-card h2 {
  font-size: 24px;
  margin-bottom: 16px;
  color: #e5e5e5;
}

.auth-card p {
  color: #999;
  margin-bottom: 8px;
  line-height: 1.6;
}

.auth-card.success {
  border-color: #2a5a2a;
}

.auth-card.success h2 {
  color: #90EE90;
}

.auth-card.error {
  border-color: #5a2a2a;
}

.auth-card.error h2 {
  color: #ff6b6b;
}

.auth-card button {
  margin-top: 16px;
  padding: 12px 24px;
  background-color: #4F46E5;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.auth-card button:hover {
  background-color: #4338CA;
}

/* User Header */
.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px;
  background: linear-gradient(180deg, #1a1a20 0%, #141418 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-email {
  color: #999;
  font-size: 14px;
}

.logout-btn {
  padding: 7px 14px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #8e8e9e;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.09);
  color: #c0c0cc;
  border-color: rgba(255, 255, 255, 0.14);
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #0e0e0e;
}

.loading-container h2 {
  color: #999;
  font-size: 20px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,yFAAyF;EACzF,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,kDAAkD;EAClD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,+EAA+E;EAC/E,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,2CAA2C;EAC3C,OAAO;EACP,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;EAGE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,kDAAkD;EAClD,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kDAAkD;AACpD;;AAEA;;EAEE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,+BAA+B;EAC/B,kDAAkD;EAClD,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;;;EAGE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yFAAyF;EACzF,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Pulse animation for reconnecting indicator */\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.4; }\n  100% { opacity: 1; }\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  background-color: #0d0d0f;\n  color: #e2e2e6;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* Dashboard Container */\n.dashboard-container {\n  width: 100%;\n  min-height: 100vh;\n  background-color: #0e0e0e;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Price Header */\n.price-header {\n  background: linear-gradient(180deg, #1e1e23 0%, #181820 100%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n}\n\n.crypto-selector {\n  position: relative;\n}\n\n.selector-button {\n  background: linear-gradient(180deg, #262630 0%, #1e1e28 100%);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  color: #e5e5e5;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.selector-button:hover {\n  background: linear-gradient(180deg, #2e2e3a 0%, #252530 100%);\n  border-color: rgba(255, 255, 255, 0.18);\n}\n\n.selected-pair {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.crypto-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background-color: #2a2a2a;\n  flex-shrink: 0;\n  object-fit: cover;\n  display: block;\n}\n\n.dropdown-arrow {\n  color: #999;\n  font-size: 12px;\n}\n\n.selector-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  background-color: #1c1c22;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  width: 320px;\n  max-height: 480px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.04);\n  z-index: 1000;\n}\n\n.search-box {\n  padding: 12px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.search-box input {\n  width: 100%;\n  background-color: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 6px;\n  padding: 10px 12px;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n}\n\n.search-box input:focus {\n  border-color: #0052ff;\n}\n\n.pairs-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.pair-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pair-item:hover {\n  background-color: #2a2a2a;\n}\n\n.pair-item.active {\n  background-color: #0052ff;\n}\n\n.pair-info {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.base-asset {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.quote-asset {\n  color: #999;\n  font-size: 13px;\n}\n\n.price-stats {\n  display: flex;\n  gap: 32px;\n  flex-wrap: wrap;\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat .value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e2e2e6;\n  font-feature-settings: 'tnum' 1;\n  letter-spacing: -0.2px;\n}\n\n.stat .label {\n  font-size: 11px;\n  color: #6e6e7a;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  font-weight: 500;\n}\n\n.stat.positive .value {\n  color: #26a69a;\n}\n\n.stat.negative .value {\n  color: #ef5350;\n}\n\n/* Trading Grid */\n.trading-grid {\n  display: grid;\n  grid-template-columns: 320px 1fr 350px;\n  gap: 1px;\n  background-color: rgba(255, 255, 255, 0.05);\n  flex: 1;\n  height: calc(100vh - 50px);\n  max-height: calc(100vh - 50px);\n}\n\n.order-book-panel,\n.chart-panel,\n.trade-history-panel {\n  background-color: #1a1a1a;\n  overflow-y: auto;\n}\n\n.order-book-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.chart-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* Order Book */\n.order-book {\n  background-color: #1a1a1a;\n  padding: 16px;\n  flex: 1;\n}\n\n.order-book h3 {\n  font-size: 11px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  color: #5a5a6a;\n  padding-left: 8px;\n  border-left: 2px solid rgba(38, 166, 154, 0.5);\n}\n\n.order-book-header {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 8px 0;\n  font-size: 10px;\n  color: #4e4e5e;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.order-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 5px 4px;\n  font-size: 12.5px;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-feature-settings: 'tnum' 1;\n  border-radius: 3px;\n  transition: background-color 0.1s ease;\n}\n\n.order-row:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.order-row.bid {\n  color: #2bbdb3;\n}\n\n.order-row.ask {\n  color: #f0564a;\n}\n\n.spread {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 10px;\n  margin: 6px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  background: rgba(38, 166, 154, 0.04);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #5a5a6e;\n  letter-spacing: 0.3px;\n}\n\n.spread-value {\n  font-weight: 600;\n  color: #c0c0cc;\n  font-feature-settings: 'tnum' 1;\n}\n\n.aggregation-control {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #2a2a2a;\n  font-size: 12px;\n}\n\n.aggregation-control button {\n  background-color: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 4px;\n  color: #e5e5e5;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.aggregation-control button:hover {\n  background-color: #333;\n}\n\n/* Price Chart */\n.price-chart-container {\n  background-color: #1a1a1a;\n  padding: 12px 16px 4px 16px;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.chart-header h3 {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  color: #5a5a6a;\n  padding-left: 8px;\n  border-left: 2px solid rgba(38, 166, 154, 0.5);\n}\n\n.chart-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.chart-controls select,\n.overlay-btn {\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  padding: 6px 12px;\n  color: #c0c0cc;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.chart-controls select:hover,\n.overlay-btn:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.chart-data-bar {\n  display: flex;\n  gap: 20px;\n  padding: 8px 0;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-family: 'Monaco', 'Courier New', monospace;\n  color: #999;\n}\n\n.chart-data-bar span {\n  color: #e5e5e5;\n}\n\n.chart-canvas {\n  width: 100%;\n  height: 515px;\n  position: relative;\n}\n\n.chart-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #666;\n  font-size: 14px;\n}\n\n.mid-market-price {\n  position: absolute;\n  top: 56px;\n  right: 32px;\n  background: rgba(18, 18, 24, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 14px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n}\n\n.price-label {\n  font-size: 11px;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.price-value {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-feature-settings: 'tnum' 1;\n  color: #2bbdb3;\n  letter-spacing: -0.3px;\n}\n\n/* Trade History */\n.trade-history {\n  background-color: #1a1a1a;\n  padding: 16px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.trade-history-header {\n  margin-bottom: 12px;\n}\n\n.trade-history-header h3 {\n  font-size: 11px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  color: #5a5a6a;\n  padding-left: 8px;\n  border-left: 2px solid rgba(38, 166, 154, 0.5);\n}\n\n.trade-history-header .columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 8px 0;\n  font-size: 10px;\n  color: #4e4e5e;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.trades-list {\n  max-height: calc(100vh - 180px);\n  overflow-y: auto;\n}\n\n.trade-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  padding: 7px 4px;\n  font-size: 11.5px;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-feature-settings: 'tnum' 1;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n  border-radius: 3px;\n  transition: background-color 0.1s ease;\n}\n\n.trade-row:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.trade-row.buy {\n  color: #2bbdb3;\n}\n\n.trade-row.sell {\n  color: #f0564a;\n}\n\n/* Loading and No Data States */\n.loading,\n.no-data,\n.no-results {\n  padding: 20px;\n  text-align: center;\n  color: #666;\n  font-size: 13px;\n}\n\n/* Orders Panel */\n.orders-panel {\n  background-color: #1a1a1a;\n  padding: 16px;\n  border-top: 1px solid #2a2a2a;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n  .trading-grid {\n    grid-template-columns: 280px 1fr 240px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .trading-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto auto;\n  }\n\n  .price-stats {\n    gap: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .price-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .price-stats {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .stat .value {\n    font-size: 16px;\n  }\n}\n\n/* Order Form */\n.order-form {\n  background-color: #1a1a1a;\n  padding: 10px 14px;\n  border-radius: 8px;\n  margin: 0 12px 8px 12px;\n  position: relative;\n  z-index: 1;\n}\n\n.order-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.order-form h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0;\n}\n\n.settings-icon-btn {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.settings-icon-btn:hover {\n  opacity: 1;\n}\n\n.side-selector {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.side-btn {\n  padding: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  background-color: rgba(255, 255, 255, 0.04);\n  color: #6e6e7e;\n}\n\n.side-btn.buy.active {\n  background: linear-gradient(135deg, #26a69a 0%, #1d8a80 100%);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(38, 166, 154, 0.3);\n}\n\n.side-btn.sell.active {\n  background: linear-gradient(135deg, #ef5350 0%, #c62828 100%);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(239, 83, 80, 0.3);\n}\n\n.side-btn:hover:not(.active) {\n  background-color: rgba(255, 255, 255, 0.07);\n  color: #a0a0b0;\n}\n\n.form-group {\n  margin-bottom: 10px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 12px;\n  color: #999;\n  margin-bottom: 6px;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 8px 10px;\n  gap: 8px;\n  transition: border-color 0.15s ease;\n}\n\n.input-group:focus-within {\n  border-color: rgba(38, 166, 154, 0.5);\n}\n\n.input-group input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n}\n\n.input-group input::placeholder {\n  color: #666;\n}\n\n.input-icon-btn {\n  background-color: #333;\n  border: none;\n  color: #999;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.input-icon-btn:hover {\n  background-color: #3a3a3a;\n}\n\n.currency {\n  color: #999;\n  font-size: 14px;\n  font-weight: 600;\n  padding-left: 8px;\n  border-left: 1px solid #3a3a3a;\n}\n\n.fee-info {\n  margin: 10px 0 8px 0;\n  padding: 10px 0;\n  border-top: 1px solid #2a2a2a;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.fee-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #999;\n  margin-bottom: 6px;\n}\n\n.fee-row:last-child {\n  margin-bottom: 0;\n}\n\n.fee-row.total-row {\n  font-weight: 600;\n  color: #e5e5e5;\n  margin-top: 6px;\n}\n\n.place-order-btn {\n  width: 100%;\n  padding: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  border: none;\n  border-radius: 7px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-top: 8px;\n}\n\n.place-order-btn.buy {\n  background: linear-gradient(135deg, #26a69a 0%, #1a8c82 100%);\n  color: #fff;\n  box-shadow: 0 2px 12px rgba(38, 166, 154, 0.25);\n}\n\n.place-order-btn.sell {\n  background: linear-gradient(135deg, #ef5350 0%, #c0392b 100%);\n  color: #fff;\n  box-shadow: 0 2px 12px rgba(239, 83, 80, 0.25);\n}\n\n.place-order-btn:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.place-order-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.place-order-btn:disabled {\n  opacity: 0.25;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Order Status Message */\n.order-status-message {\n  padding: 10px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  border-radius: 6px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  animation: slideIn 0.3s ease-in-out;\n}\n\n.order-status-message.success {\n  background-color: #1a3a1a;\n  border: 1px solid #2a5a2a;\n  color: #90EE90;\n}\n\n.order-status-message.error {\n  background-color: #3a1a1a;\n  border: 1px solid #5a2a2a;\n  color: #ff6b6b;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Settings Modal */\n.settings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  padding: 20px;\n}\n\n.settings-modal {\n  background: linear-gradient(180deg, #1e1e24 0%, #181820 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.04);\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.settings-header h3 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 4px 0;\n}\n\n.settings-subtitle {\n  font-size: 13px;\n  color: #999;\n  margin: 0;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 32px;\n  color: #999;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  transition: color 0.2s;\n}\n\n.close-btn:hover {\n  color: #e5e5e5;\n}\n\n.settings-section {\n  margin-bottom: 32px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin-bottom: 16px;\n}\n\n.toggle-indicator {\n  color: #26a69a;\n  font-size: 12px;\n}\n\n.slider-group {\n  background-color: #2a2a2a;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.slider {\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(to right, #26a69a 0%, #26a69a 25%, #3a3a3a 25%, #3a3a3a 100%);\n  border-radius: 2px;\n  outline: none;\n  margin-bottom: 12px;\n  -webkit-appearance: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #26a69a;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #26a69a;\n  cursor: pointer;\n  border: none;\n}\n\n.slider-labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  color: #999;\n}\n\n.slider-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #1a1a1a;\n  padding: 6px 12px;\n  border-radius: 6px;\n}\n\n.slider-value span:first-child {\n  color: #e5e5e5;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.pause-btn {\n  background: transparent;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0 4px;\n}\n\n.participants-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.participant-card {\n  background-color: #2a2a2a;\n  border: 2px solid #2a2a2a;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s;\n}\n\n.participant-card.active {\n  border-color: #26a69a;\n  background-color: rgba(38, 166, 154, 0.1);\n}\n\n.participant-card:hover {\n  background-color: #333;\n}\n\n.participant-card.active:hover {\n  background-color: rgba(38, 166, 154, 0.15);\n}\n\n.card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin-bottom: 4px;\n}\n\n.card-subtitle {\n  font-size: 12px;\n  color: #999;\n}\n\n.execution-mode-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.mode-card {\n  background-color: #2a2a2a;\n  border: 2px solid #2a2a2a;\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.mode-card.active {\n  border-color: #26a69a;\n  background-color: #26a69a;\n}\n\n.mode-card:hover:not(.active) {\n  background-color: #333;\n}\n\n.mode-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin-bottom: 8px;\n}\n\n.mode-subtitle {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  margin-bottom: 4px;\n}\n\n.mode-card:not(.active) .mode-subtitle {\n  color: #999;\n}\n\n.mode-detail {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.mode-card:not(.active) .mode-detail {\n  color: #666;\n}\n\n.provider-type-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.provider-type-card {\n  background-color: #2a2a2a;\n  border: 2px solid #2a2a2a;\n  border-radius: 8px;\n  padding: 12px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s;\n}\n\n.provider-type-card:first-child {\n  grid-column: 1 / -1;\n}\n\n.provider-type-card.active {\n  border-color: #26a69a;\n  background-color: rgba(38, 166, 154, 0.1);\n}\n\n.provider-type-card:hover {\n  background-color: #333;\n}\n\n.provider-type-card.active:hover {\n  background-color: rgba(38, 166, 154, 0.15);\n}\n\n.settings-section--disabled {\n  opacity: 0.4;\n  pointer-events: none;\n  user-select: none;\n}\n\n.coming-soon-badge {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: #6e6e7e;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  padding: 3px 8px;\n}\n\n.settings-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #2a2a2a;\n}\n\n.reset-btn {\n  flex: 1;\n  padding: 14px;\n  background-color: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 8px;\n  color: #e5e5e5;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.reset-btn:hover {\n  background-color: #333;\n}\n\n.save-btn {\n  flex: 2;\n  padding: 14px;\n  background: linear-gradient(135deg, #26a69a 0%, #1a8c82 100%);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 10px rgba(38, 166, 154, 0.25);\n}\n\n.save-btn:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(38, 166, 154, 0.35);\n}\n\n/* Authentication Styles */\n.login-container,\n.verify-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 24px;\n  background-color: #0e0e0e;\n}\n\n.login-container h1 {\n  color: #e5e5e5;\n  margin-bottom: 32px;\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.login-container form {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.login-container input[type=\"email\"] {\n  padding: 14px 16px;\n  font-size: 16px;\n  background-color: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 8px;\n  color: #e5e5e5;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.login-container input[type=\"email\"]:focus {\n  border-color: #4F46E5;\n}\n\n.login-container input[type=\"email\"]::placeholder {\n  color: #666;\n}\n\n.login-container button {\n  padding: 14px 16px;\n  font-size: 16px;\n  font-weight: 500;\n  background-color: #4F46E5;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.login-container button:hover:not(:disabled) {\n  background-color: #4338CA;\n}\n\n.login-container button:disabled {\n  background-color: #2a2a2a;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.success-message,\n.error-message {\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: 8px;\n  text-align: center;\n  max-width: 400px;\n}\n\n.success-message {\n  background-color: #1a3a1a;\n  border: 1px solid #2a5a2a;\n  color: #90EE90;\n}\n\n.success-message h2 {\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n\n.error-message {\n  background-color: #3a1a1a;\n  border: 1px solid #5a2a2a;\n  color: #ff6b6b;\n}\n\n.auth-card {\n  background-color: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 12px;\n  padding: 32px;\n  max-width: 400px;\n  text-align: center;\n}\n\n.auth-card h2 {\n  font-size: 24px;\n  margin-bottom: 16px;\n  color: #e5e5e5;\n}\n\n.auth-card p {\n  color: #999;\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n.auth-card.success {\n  border-color: #2a5a2a;\n}\n\n.auth-card.success h2 {\n  color: #90EE90;\n}\n\n.auth-card.error {\n  border-color: #5a2a2a;\n}\n\n.auth-card.error h2 {\n  color: #ff6b6b;\n}\n\n.auth-card button {\n  margin-top: 16px;\n  padding: 12px 24px;\n  background-color: #4F46E5;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.auth-card button:hover {\n  background-color: #4338CA;\n}\n\n/* User Header */\n.user-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 24px;\n  background: linear-gradient(180deg, #1a1a20 0%, #141418 100%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-email {\n  color: #999;\n  font-size: 14px;\n}\n\n.logout-btn {\n  padding: 7px 14px;\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #8e8e9e;\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.logout-btn:hover {\n  background-color: rgba(255, 255, 255, 0.09);\n  color: #c0c0cc;\n  border-color: rgba(255, 255, 255, 0.14);\n}\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background-color: #0e0e0e;\n}\n\n.loading-container h2 {\n  color: #999;\n  font-size: 20px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
